/*
    Imports the HMB API URL from the config.
*/
import {APP_CONFIG} from "../config";

export default {
    /*
        GET     /api/v1/briefs
    */
    getBriefs: function () {
        return axios.get(`${APP_CONFIG.URL}user/apps`);
    },

    /*
  GET   /api/v1/briefs/{cafeID}
*/
    getPGSetting: function (project) {
        return axios.get(`${APP_CONFIG.URL}projects/` + project + `/pg/settings/get`, {
            params: {
                project: project
            }
        });
    },

    /*
  POST  /api/v1/briefs
*/
    postCreatePGSettings: function (project, pub_key) {

        console.log("POST data API " + project + " - " + pub_key);

        let formData = new FormData();
        formData.append('project', project);
        formData.append('pk', pub_key);

        return axios.post(`${APP_CONFIG.URL}projects/` + project + `/pg/settings/create`,
            formData
        );
    }
}
